import { render, staticRenderFns } from "./z-scroll.vue?vue&type=template&id=9db4b322&"
import script from "./z-scroll.vue?vue&type=script&lang=js&"
export * from "./z-scroll.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports